import type { ReactNode } from 'react'

import { cx } from '@/Ship/Helpers/cssClass'

import styles from './FormSection.module.css'

interface FormSectionProps {
    /** Заголовок секції; без нього — лише група полів з роздільником зверху */
    title?: ReactNode
    /** Пояснення під заголовком */
    hint?: ReactNode
    className?: string
    children: ReactNode
}

/**
 * Секція форми в картці: група полів з необов'язковим заголовком. Між секціями —
 * тонкий роздільник, без рамки й тіні (картка в drawer і так одна).
 * Заміна `Card` у власних шаблонах форм.
 */
export const FormSection = ({ title, hint, className, children }: FormSectionProps) => (
    <section className={`${cx(styles, 'section')} ${className ?? ''}`}>
        {title && <h3 className={cx(styles, 'title')}>{title}</h3>}
        {hint && <p className={cx(styles, 'hint')}>{hint}</p>}
        {children}
    </section>
)
